import React from 'react';
import css from './FilterRow.module.scss';
import classNames from 'classnames';

export interface ISearchGridFilterRowProps {
    children: any;
    formFilter?: boolean;
}

export const FilterRow = React.memo<ISearchGridFilterRowProps>((props) => (
    <div className={classNames(css.filterRow, { [css.formFilter]: props.formFilter })}>{props.children}</div>
));
